/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BaseHttpRequest } from './core/BaseHttpRequest'
import type { OpenAPIConfig } from './core/OpenAPI'
import { AxiosHttpRequest } from './core/AxiosHttpRequest'

import { ApiApplicationsService } from './services/ApiApplicationsService'
import { AppConfigService } from './services/AppConfigService'
import { AuthenticationService } from './services/AuthenticationService'
import { BreezeManagementHooksService } from './services/BreezeManagementHooksService'
import { CancellationService } from './services/CancellationService'
import { FeaturesService } from './services/FeaturesService'
import { FeaturesIntegrationsService } from './services/FeaturesIntegrationsService'
import { GlobalMessageTemplatesService } from './services/GlobalMessageTemplatesService'
import { MessageTemplatesService } from './services/MessageTemplatesService'
import { MetricsService } from './services/MetricsService'
import { NavigationService } from './services/NavigationService'
import { OrganizationsService } from './services/OrganizationsService'
import { OrganizationsActionsService } from './services/OrganizationsActionsService'
import { OrganizationsBulkActionsService } from './services/OrganizationsBulkActionsService'
import { OrganizationsMdsService } from './services/OrganizationsMdsService'
import { OrganizationsMdsUtilitiesService } from './services/OrganizationsMdsUtilitiesService'
import { OrganizationsRolesService } from './services/OrganizationsRolesService'
import { OrganizationsStripeSubscriptionsService } from './services/OrganizationsStripeSubscriptionsService'
import { OrganizationsUsersService } from './services/OrganizationsUsersService'
import { RetryableJobsService } from './services/RetryableJobsService'
import { SsoSamlLoginService } from './services/SsoSamlLoginService'
import { SsoSamlRoleMappingService } from './services/SsoSamlRoleMappingService'
import { SsoSamlTenantsService } from './services/SsoSamlTenantsService'
import { UsersService } from './services/UsersService'
import { UsersRolesService } from './services/UsersRolesService'
import { EmailSuppressionsService } from './services/EmailSuppressionsService'
import { IpAllowlistService } from './services/IpAllowlistService'
import { SmsBlacklistService } from './services/SmsBlacklistService'
import { CountriesService } from './services/CountriesService'
import { DashboardService } from './services/DashboardService'
import { OrganizationsFavoritesService } from './services/OrganizationsFavoritesService'
import { OrganizationsEmailSettingsService } from './services/OrganizationsEmailSettingsService'
import { OrganizationsMessagingService } from './services/OrganizationsMessagingService'
import { MessagingScheduledService } from './services/MessagingScheduledService'
import { MessagingRunsService } from './services/MessagingRunsService'

type HttpRequestConstructor = new (config: OpenAPIConfig) => BaseHttpRequest

export class HelmClient {
    public readonly apiApplications: ApiApplicationsService
    public readonly appConfig: AppConfigService
    public readonly authentication: AuthenticationService
    public readonly breezeManagementHooks: BreezeManagementHooksService
    public readonly cancellation: CancellationService
    public readonly features: FeaturesService
    public readonly featuresIntegrations: FeaturesIntegrationsService
    public readonly globalMessageTemplates: GlobalMessageTemplatesService
    public readonly messageTemplates: MessageTemplatesService
    public readonly metrics: MetricsService
    public readonly navigation: NavigationService
    public readonly organizations: OrganizationsService
    public readonly organizationsActions: OrganizationsActionsService
    public readonly organizationsBulkActions: OrganizationsBulkActionsService
    public readonly organizationsMds: OrganizationsMdsService
    public readonly organizationsMdsUtilities: OrganizationsMdsUtilitiesService
    public readonly organizationsRoles: OrganizationsRolesService
    public readonly organizationsStripeSubscriptions: OrganizationsStripeSubscriptionsService
    public readonly organizationsUsers: OrganizationsUsersService
    public readonly retryableJobs: RetryableJobsService
    public readonly ssoSamlLogin: SsoSamlLoginService
    public readonly ssoSamlRoleMapping: SsoSamlRoleMappingService
    public readonly ssoSamlTenants: SsoSamlTenantsService
    public readonly users: UsersService
    public readonly usersRoles: UsersRolesService

    public readonly request: BaseHttpRequest
    public readonly emailSuppressions: EmailSuppressionsService
    public readonly ipAllowlist: IpAllowlistService
    public readonly smsBlacklist: SmsBlacklistService
    public readonly countries: CountriesService
    public readonly dashboard: DashboardService
    public readonly organizationsFavorites: OrganizationsFavoritesService
    public readonly organizationsEmailSettings: OrganizationsEmailSettingsService
    public readonly organizationsMessaging: OrganizationsMessagingService
    public readonly messagingScheduled: MessagingScheduledService
    public readonly messagingRuns: MessagingRunsService

    constructor(config?: Partial<OpenAPIConfig>, HttpRequest: HttpRequestConstructor = AxiosHttpRequest) {
        this.request = new HttpRequest({
            BASE: config?.BASE ?? 'https://api.breezechms.test/helm/v1',
            VERSION: config?.VERSION ?? '2023-06-09',
            WITH_CREDENTIALS: config?.WITH_CREDENTIALS ?? false,
            CREDENTIALS: config?.CREDENTIALS ?? 'include',
            TOKEN: config?.TOKEN,
            USERNAME: config?.USERNAME,
            PASSWORD: config?.PASSWORD,
            HEADERS: config?.HEADERS,
            ENCODE_PATH: config?.ENCODE_PATH
        })

        this.apiApplications = new ApiApplicationsService(this.request)
        this.appConfig = new AppConfigService(this.request)
        this.authentication = new AuthenticationService(this.request)
        this.breezeManagementHooks = new BreezeManagementHooksService(this.request)
        this.cancellation = new CancellationService(this.request)
        this.features = new FeaturesService(this.request)
        this.featuresIntegrations = new FeaturesIntegrationsService(this.request)
        this.globalMessageTemplates = new GlobalMessageTemplatesService(this.request)
        this.messageTemplates = new MessageTemplatesService(this.request)
        this.metrics = new MetricsService(this.request)
        this.navigation = new NavigationService(this.request)
        this.organizations = new OrganizationsService(this.request)
        this.organizationsActions = new OrganizationsActionsService(this.request)
        this.organizationsBulkActions = new OrganizationsBulkActionsService(this.request)
        this.organizationsMds = new OrganizationsMdsService(this.request)
        this.organizationsMdsUtilities = new OrganizationsMdsUtilitiesService(this.request)
        this.organizationsRoles = new OrganizationsRolesService(this.request)
        this.organizationsStripeSubscriptions = new OrganizationsStripeSubscriptionsService(this.request)
        this.organizationsUsers = new OrganizationsUsersService(this.request)
        this.retryableJobs = new RetryableJobsService(this.request)
        this.ssoSamlLogin = new SsoSamlLoginService(this.request)
        this.ssoSamlRoleMapping = new SsoSamlRoleMappingService(this.request)
        this.ssoSamlTenants = new SsoSamlTenantsService(this.request)
        this.users = new UsersService(this.request)
        this.usersRoles = new UsersRolesService(this.request)
        this.emailSuppressions = new EmailSuppressionsService(this.request)
        this.ipAllowlist = new IpAllowlistService(this.request)
        this.smsBlacklist = new SmsBlacklistService(this.request)
        this.countries = new CountriesService(this.request)
        this.dashboard = new DashboardService(this.request)
        this.organizationsFavorites = new OrganizationsFavoritesService(this.request)
        this.organizationsEmailSettings = new OrganizationsEmailSettingsService(this.request)
        this.organizationsMessaging = new OrganizationsMessagingService(this.request)
        this.messagingScheduled = new MessagingScheduledService(this.request)
        this.messagingRuns = new MessagingRunsService(this.request)
    }
}
